module.exports = __webpack_public_path__ + "static/img/logo_5.09d765a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/logo_5.png
// module id = ANbF
// module chunks = 3